module.exports = __webpack_public_path__ + "img/chart.ee47c226.svg";